import i18n from '../../../i18n'
import {
  ACTION_GET_PROFILE,
  ACTION_SAVE_PROFILE,
  SET_PROFILE,
  SET_NICKNAME,
} from '../../types/profile.types'
import { ACTION_SET_ALERT } from '../../types/alerts.types'
import { getProfile, saveProfile } from '../../../api/profile'

export default {
  [ACTION_GET_PROFILE]: ({ commit }) => {
    getProfile()
      .then((result) => {
        commit(SET_NICKNAME, result.data.nickname)
        commit(SET_PROFILE, result.data.profile)
      })
      .catch((error) => {
        console.log(error)
      })
  },
  [ACTION_SAVE_PROFILE]: ({ commit, dispatch }, payload) => {
    saveProfile({ ...payload.profile })
      .then(() => {
        commit(SET_PROFILE, payload.profile)
        if (payload.showAlert) {
          const alert = { type: 'success', message: i18n.t('alerts.saveProfileSuccess') }
          dispatch(ACTION_SET_ALERT, alert)
        }
      })
      .catch((error) => {
        console.log(error)
        const alert = { type: 'error', message: i18n.t('alerts.saveProfileError') }
        dispatch(ACTION_SET_ALERT, alert)
      })
  },
}
